import React, { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./styles/App.less";
import { routes } from "common/routes";
import { rootReducerType } from "./redux/combineReducers";
import Header from "./common/components/Header/Header";
import "./styles/App.less";
import { useSelector } from "react-redux";
import "@fontsource/montserrat";
import Slibar from "./components/Slibar/Slibar"
import useWindowDimensions from "common/functions";


function App() {
	const { isLoggedIn } = useSelector(
		(state: rootReducerType) => state.authenticationReducer
	);

	const [refresh, setRefresh] = useState(false);

	const [tabProfile, setTabProfile] = useState<string>("1");

	const { width } = useWindowDimensions();

	return (
		<div className="app-container">
			<Routes>
				{routes
					.filter((route) => !route?.disabled)
					.map((route, index) =>
						route.private && isLoggedIn ? (
							<Route
								key={index}
								path={route.path}
								element={ 
									<>
										<div style={{ display: 'flex', height: '100%', width: '100%', overflow: 'hidden' }}>
										    {width > 768 ? <Slibar /> : null} 
											<div style={{ height: '100%', flex: '1', display: 'flex',flexDirection: 'column' }}>
												<Header
													setRefreshButton={() => setRefresh(!refresh)}
													shouldRefresh={refresh}
													setTabProfile={setTabProfile}
												/>
												<div style={{ display: 'flex', height: '100%', flex: '1', overflow: 'hidden' }}>
													<route.element
														shouldRefresh={refresh}
														tabProfile={tabProfile}
														setTabProfile={setTabProfile}
													/>
												</div>
											</div>
										</div>
									</>
								}
							/>
						) : route.private && !isLoggedIn ? (
							<Navigate to="/" />
						) : (
							<Route
								key={index}
								path={route.path}
								element={<route.element />}
							/>
						)
					)}
			</Routes>
		</div>
	);
}

export default App;
